import GuestHeaderMenu from './GuestHeaderMenu'

export default GuestHeaderMenu
